import { DataLakeEnums, DataLakeReadableConsts } from 'dashboard-services/api/dataLake';
import { ReduxService } from 'dashboard-services/services';

import { filesDatalakeActions } from 'actions/modules/datalake';

const emptyField = {
  name: "",
  value: "",
  type: "STRING",
  canBeRemoved: true
}
export const filesInitialState = {
  group: {},

  // file details
  selectedFile: undefined,
  selectedFileVersion: undefined,
  selectedFileWriteAccess: undefined,
  detailsMenuTab: undefined,

  // file upload
  uploadedFiles: [],
  uploadedFilesName: [],
  errors: [],
  isOpen: false,
  fields: [],
  groupName: undefined,
  dataStart: undefined,
  dataEnd: undefined,
  name: "",
  partialUpdate: false,
  avoidDuplicates: false,
  skipMetadata: false,
  dataStartDate: undefined,
  dataStartTime: "00:00",
  dataEndDate: undefined,
  dataEndTime: "23:59",
  withDataRange: false,
  type: DataLakeReadableConsts.FILE_TYPES.find(dl => dl?.value === DataLakeEnums.FILE_TYPE.SOURCE),

  // statuses + drag&drop
  dropDepth: 0,

  selectedFiles: []
}

export default (state = filesInitialState, action) => {
  switch (action.type) {
    case filesDatalakeActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value, errors: (state.errors || []).filter(e => e.field !== `${action.name}`) })
      }
      return state;
    }
    case filesDatalakeActions.ADD_FIELD:
      return ReduxService.updateObject(state, { fields: state.fields.add(emptyField) })
    case filesDatalakeActions.REMOVE_FIELD:
      return ReduxService.updateObject(state, { fields: state.fields.remove(action.index) })
    case filesDatalakeActions.CHANGE_FIELD:
      return ReduxService.updateObject(state, { fields: state.fields.updateInList({ [action.name]: action.value }, action.index) })
    case filesDatalakeActions.SET_FIELDS:
      return ReduxService.updateObject(state, { fields: action.fields.map(f => ({ name: f.name, value: f.defaultValue || "", type: f.type, canBeRemoved: false })) })
    case filesDatalakeActions.SET_DROP_DEPTH:
      return ReduxService.updateObject(state, { dropDepth: action.value })
    case filesDatalakeActions.ADD_UPLOADED_FILE:
      return ReduxService.updateObject(state, { uploadedFiles: state.uploadedFiles.add(action.item), uploadedFilesName: (state.uploadedFiles.length === state.uploadedFilesName.length ? state.uploadedFilesName.add(action.item.name) : state.uploadedFilesName) })
    case filesDatalakeActions.REMOVE_UPLOADED_FILE:
      return ReduxService.updateObject(state, { uploadedFiles: state.uploadedFiles.remove(action.index), uploadedFilesName: state.uploadedFilesName.remove(action.index) })
    case filesDatalakeActions.CHANGE_UPLOADED_FILE_NAME:
      return ReduxService.updateObject(state, { uploadedFilesName: state.uploadedFilesName.replace(action.value, action.index) })
    case filesDatalakeActions.CLEAR_UPLOAD_DIALOG:
      return ReduxService.updateObject(state, {
        uploadedFiles: filesInitialState.uploadedFiles,
        uploadedFilesName: filesInitialState.uploadedFilesName,
        errors: filesInitialState.errors,
        fields: filesInitialState.fields,
        groupName: filesInitialState.groupName,
        partialUpdate: filesInitialState.partialUpdate,
        avoidDuplicates: filesInitialState.avoidDuplicates,
        skipMetadata: filesInitialState.skipMetadata,
        dataStartDate: filesInitialState.dataStartDate,
        dataStartTime: filesInitialState.dataStartTime,
        dataEndDate: filesInitialState.dataEndDate,
        dataEndTime: filesInitialState.dataEndTime,
        withDataRange: filesInitialState.withDataRange,
        type: filesInitialState.type,
      })
    default:
      return state;
  }
}